/* Aviso del inicio: acciones correctivas de Levantamientos de Condiciones
 * Inseguras (SST) asignadas al usuario y pendientes de cargar (nuevas o
 * devueltas por quien inició el caso).
 *
 * - No pinta nada si no tiene ninguna (o si falla la consulta).
 * - Cada fila abre el detalle para cargar las acciones; la tarjeta abre la lista.
 * - El punto de color es el semáforo del SLA: verde en día, amarillo si vence
 *   hoy o mañana, rojo si ya venció.
 */
import { useIonViewWillEnter } from "@ionic/react";
import { Typography } from "@material-ui/core";
import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import SemaforoChip from "src/components/SemaforoSla";
import SstAPI, { COLORES_SEMAFORO, LevantamientoResumen } from "src/services/sst";

const MAX_FILAS = 3;

const AccionesCorrectivasCard: React.FC = () => {
  const history = useHistory();
  const [items, setItems] = useState<LevantamientoResumen[]>([]);

  const cargar = useCallback(() => {
    SstAPI.listar(true)
      .then((r) => setItems(r.data.data || []))
      .catch(() => setItems([]));
  }, []);

  useEffect(() => {
    cargar();
  }, [cargar]);

  // El inicio queda montado: al volver (p. ej. después de responder) se refresca.
  useIonViewWillEnter(() => {
    cargar();
  }, [cargar]);

  if (!items.length) return null;

  const vencidas = items.filter((l) => l.semaforo.color === "rojo").length;
  const peor = vencidas ? "rojo" : items.some((l) => l.semaforo.color === "amarillo") ? "amarillo" : "verde";

  return (
    <div className="container mt-1">
      <div
        onClick={() => history.push("/sst/acciones-correctivas")}
        style={{
          cursor: "pointer",
          background: "#fff",
          borderRadius: 10,
          borderLeft: `6px solid ${COLORES_SEMAFORO[peor].texto}`,
          boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
          padding: "12px 14px",
          marginBottom: 10,
        }}
      >
        <Typography variant="caption" style={{ color: "var(--garnet, #910434)", fontWeight: 700 }}>
          ⚠️ ACCIONES CORRECTIVAS · CONDICIONES INSEGURAS
        </Typography>
        <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
          {items.length === 1
            ? "Tenés 1 acción correctiva pendiente"
            : `Tenés ${items.length} acciones correctivas pendientes`}
          {vencidas > 0 && (
            <span style={{ color: COLORES_SEMAFORO.rojo.texto, fontSize: 13, fontWeight: 600 }}>
              {" "}
              · {vencidas} vencida{vencidas > 1 ? "s" : ""}
            </span>
          )}
        </Typography>

        {items.slice(0, MAX_FILAS).map((l) => (
          <div
            key={l.id}
            onClick={(e) => {
              e.stopPropagation();
              history.push(`/sst/acciones-correctivas/${l.id}`);
            }}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 8,
              fontSize: 13,
              padding: "6px 0",
              borderTop: "1px solid #eee",
            }}
          >
            <span style={{ flex: 1 }}>
              N° {l.id} · {l.anomalia}
              {l.estado === "DEVUELTO" && <span style={{ color: "#b21f2d" }}> (devuelta)</span>}
            </span>
            <SemaforoChip semaforo={l.semaforo} />
          </div>
        ))}

        <Typography variant="caption" style={{ color: "var(--garnet, #910434)", fontWeight: 600 }}>
          {items.length > MAX_FILAS ? `Ver las ${items.length} →` : "Tocá para cargar las acciones →"}
        </Typography>
      </div>
    </div>
  );
};

export default AccionesCorrectivasCard;
